import Modal from "@/components/common/modal";
import { DialogFooter } from "@/components/ui/dialog";
import { cn } from "@/utils/theme";
import { Button /*Icon*/, Icon } from "@elaniintc/goes-design-system";

interface Props {
  isOpen: boolean;
  isActive: boolean;
  onClose: () => void;
  isLoading?: boolean;
  onAccept: () => void;
}

const DeactivateModal = ({
  isOpen,
  isActive,
  isLoading,
  onClose,
  onAccept,
}: Props) => {
  const text = isActive ? "Desactivar" : "Activar";
  return (
    <Modal
      isOpen={isOpen}
      onClose={onClose}
      title={`${text} Rol`}
      description={`¿Estás seguro de que deseas ${text.toLocaleLowerCase()} este rol? Puedes ${isActive ? "activarlo" : "desactivarlo"} desde la tabla en cualquier momento.`}
      modalContentClassName="max-w-[520px] w-full gap-7"
    >
      <DialogFooter className="pt-1">
        <div className="w-full grid grid-cols-1 tablet:grid-cols-2 gap-3">
          <Button
            size="lg"
            type="button"
            className="w-full rounded-lg cursor-pointer"
            variant="tertiary"
            onClick={onClose}
          >
            Cancelar
          </Button>
          <Button
            size="lg"
            variant={isActive ? "danger-secondary" : "secondary"}
            className="w-full rounded-lg cursor-pointer"
            type="submit"
            disabled={isLoading}
            onClick={onAccept}
          >
            {text}
            {isLoading && (
              <Icon
                type="far"
                name={"spinner-third"}
                className={cn("text-current", "animate-spin")}
              />
            )}
          </Button>
        </div>
      </DialogFooter>
    </Modal>
  );
};

export default DeactivateModal;
